export class Payment {
  constructor() {
    this._button = document.querySelector('[data-payment-button]');

    this._clickHandle = this._clickHandle.bind(this);
  }

  init() {
    if (!this._button) {
      return;
    }

    this._button.addEventListener('click', this._clickHandle);
  }

  async _clickHandle(evt) {
    evt.preventDefault();

    try {
      const response = await fetch('/local/templates/ballet/ajax/payment.php', {
        method: 'GET',
      });
  
      const result = await response.text();
  
      console.log(result);
    } catch (err) {
      console.log('Error: ' + err);
    }
  }
}